module.exports = __webpack_public_path__ + "img/frame (88).564d0a11.jpg";